/**
 * English translations
 * 英文翻译
 */

export default {
  common: {
    loading: 'Loading...',
    error: 'An error occurred',
    retry: 'Retry',
    cancel: 'Cancel',
    confirm: 'Confirm',
    save: 'Save',
    saving: 'Saving...',
    delete: 'Delete',
    edit: 'Edit',
    close: 'Close',
    back: 'Back',
    backHome: 'Back to Home',
    next: 'Next',
    submit: 'Submit',
    upload: 'Upload',
    download: 'Download',
    send: 'Send',
    or: 'or',
    redirecting: 'Redirecting...',
    minutes: 'minutes',
    refresh: 'Refresh',
  },
  home: {
    codePlaceholder: 'ABC123',
    join: 'Join',
  },
  dashboard: {
    greetingMorning: 'Good morning',
    greetingAfternoon: 'Good afternoon',
    greetingEvening: 'Good evening',
    subtitle: 'Your workshop sessions',
    joinNew: 'Join New Session',
    activeSessions: 'Active Sessions',
    pastSessions: 'Past Sessions',
    noActiveSessions: 'No active sessions',
    noPastSessions: 'No past sessions',
    code: 'Code',
    joinedOn: 'Joined',
    roleHost: 'Host',
    roleParticipant: 'Participant',
    statusActive: 'Active',
    statusWaiting: 'Waiting',
    statusEnded: 'Ended',
    archived: 'Archived',
    rejoin: 'Rejoin',
    viewSummary: 'View Summary',
  },
  auth: {
    login: 'Login',
    register: 'Register',
    logout: 'Logout',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    nickname: 'Nickname',
    enterNickname: 'Enter your nickname',
    enterPassword: 'Enter your password',
    rememberMe: 'Remember me',
    forgotPassword: 'Forgot password?',
    wechatLogin: 'Login with WeChat',
    loginWithEmail: 'Login with Email',
    noAccount: "Don't have an account?",
    hasAccount: 'Already have an account?',
    registerNow: 'Register now',
    loginNow: 'Login now',
    profileSetup: 'Set up your profile',
    uploadAvatar: 'Upload avatar',
    processing: 'Processing authentication...',
  },
  profile: {
    editProfile: 'Edit Profile',
    uploadAvatar: 'Upload Avatar',
    changeAvatar: 'Change Avatar',
    clickToUpload: 'Click to upload',
    nickname: 'Nickname',
    nicknamePlaceholder: 'Enter your nickname',
    saveProfile: 'Save',
    profileSaved: 'Profile saved successfully',
    lightMode: 'Light Mode',
    darkMode: 'Dark Mode',
    switchLanguage: 'Switch Language',
    switchToHost: 'Switch to Host View',
    switchToParticipant: 'Switch to Participant View',
    switchWorkshop: 'Switch Workshop',
    switchWorkshopHint: 'Leave current workshop and join another',
    confirmLeave: 'Leave current workshop?',
    confirmLeaveHint: 'You can rejoin later with the same code.',
    invalidImageType: 'Please select an image file',
    imageTooLarge: 'Image must be smaller than 5MB',
    avatarUploadFailed: 'Failed to upload avatar',
    saveFailed: 'Failed to save profile',
    anonymous: 'Anonymous',
  },
  workshop: {
    joinWorkshop: 'Join Workshop',
    joining: 'Joining workshop...',
    enterCode: 'Enter workshop code',
    scanQR: 'Scan QR Code',
    workshop: 'Workshop',
    code: 'Workshop Code',
    participants: 'Participants',
    teams: 'Teams',
    materials: 'Materials',
    timer: 'Timer',
    agenda: 'Agenda',
    phase: 'Phase',
    phaseControl: 'Phase Control',
    appearanceDescription: 'Describe your appearance',
    appearancePlaceholder: 'E.g., wearing a blue shirt, short hair, glasses...',
    appearanceHint: 'This helps others recognize you during the workshop.',
  },
  phases: {
    selfIntro: 'Self Introduction',
    adIntro: 'Audio Description Intro',
    examples: 'Example Videos',
    techGuide: 'Technical Guidance',
    interactive: 'Interactive Practice',
    creation: 'Creation',
    team: 'Team Formation',
    recording: 'Recording',
    sharing: 'Sharing',
    wrapup: 'Wrap-up',
    summary: 'Summary',
  },
  roles: {
    describer: 'Describer',
    describer_desc: 'Describe images verbally for audio description',
    aiOperator: 'AI Operator',
    aiOperator_desc: 'Operate AI tools based on partner guidance',
    host: 'Host',
    participant: 'Participant',
  },
  team: {
    team: 'Team',
    teams: 'Teams',
    yourTeam: 'Your Team',
    teamNumber: 'Team {number}',
    teamMaterial: 'Assigned Material',
    members: 'Team Members',
    comments: 'Comments',
    addComment: 'Add a comment...',
    writeComment: 'Write a comment...',
    noComments: 'No comments yet',
    capturePhoto: 'Capture Photo',
    uploadPhoto: 'Upload Photo',
    uploadVideo: 'Upload Video',
    uploadMedia: 'Upload Media',
    formation: 'Team Formation',
    randomize: 'Random Assignment',
    notFormed: 'Teams not yet formed',
    you: 'You',
    partner: 'Partner',
    selectRole: 'Select Your Role',
    select: 'Select',
    selected: 'Selected',
    partnerSelected: 'Partner selected',
    roleConflict: 'Both selected the same role! Please choose different roles.',
    roleConflictTitle: 'Role Conflict',
    swapRoles: 'Swap Roles',
    loading: 'Loading team data...',
    readyToProceed: 'Ready! Waiting for host to start Phase 3',
    phaseNavigation: 'Phase Navigation',
    viewPhase: 'View Phase',
    currentPhase: 'Current',
    viewingPastPhase: 'Viewing past phase',
    backToCurrentPhase: 'Back to current phase',
    // PhotoCapture translations / 照片拍摄翻译
    cameraNotSupported: 'Camera is not supported in this browser',
    cameraPermissionDenied: 'Camera permission denied. Please allow camera access.',
    cameraNotFound: 'No camera found on this device',
    cameraError: 'Could not access camera. Please check permissions.',
    capturedPhoto: 'Captured photo',
    readyToCapture: 'Ready to capture',
    startingCamera: 'Starting camera...',
    openCamera: 'Open Camera',
    retake: 'Retake',
    captureHint: 'Take a photo of your team\'s work',
    captureError: 'Failed to capture photo',
  },
  teamManage: {
    title: 'Manage Teams',
    editTeams: 'Edit Teams',
    createTeam: 'New Team',
    deleteTeam: 'Delete Team',
    unassigned: 'Unassigned',
    emptyTeam: 'Drop participants here',
    allAssigned: 'All participants assigned',
    dragHint: 'Drag participants to move between teams, or click to select then click target team',
    cannotDeleteWithMembers: 'Cannot delete team with members. Remove members first.',
  },
  qr: {
    roomCode: 'Room Code',
    copyCode: 'Copy Code',
    participants: 'Participants',
    viewAll: 'View All',
    regenerate: 'Regenerate',
    expiresIn: 'Expires in {time}',
    expired: 'Expired',
    expiresInDays: '{days} days',
    expiresInHours: '{hours} hours',
    expiresInMinutes: '{minutes} min',
    expiresInSeconds: '{seconds} sec',
  },
  ai: {
    generation: 'AI Generation',
    generateImage: 'Generate Image',
    generateVideo: 'Generate Video',
    imageDesc: 'Create images with AI',
    videoDesc: 'Create videos with AI',
    prompt: 'Prompt',
    promptPlaceholder: 'Describe what you want to generate...',
    enterPrompt: 'Describe what you want to generate...',
    generating: 'Generating...',
    quotaRemaining: '{count} remaining',
    requestMore: 'Request More',
    quotaExhausted: 'Quota exhausted',
    comingSoon: 'AI generation coming soon...',
    negativePrompt: 'Negative Prompt',
    negativePromptHint: 'Describe what you do not want',
    negativePromptPlaceholder: 'E.g., low quality, blurry, watermark...',
    imageSize: 'Image Size',
    videoDuration: 'Video Duration',
    seconds: 'sec',
    generate: 'Generate',
    regenerate: 'Regenerate',
    save: 'Save',
    saved: 'Saved',
    progress: 'Progress',
    waitingForResult: 'Generating, please wait...',
    progressHint: 'This may take a few minutes...',
    generationFailed: 'Generation failed',
    noApiKey: 'No API key configured',
    noApiKeyHint: 'Please contact host to configure DashScope API key',
    configureApiKey: 'Configure API Key',
    apiKeyPlaceholder: 'Enter DashScope API key',
    apiKeySaved: 'API key saved',
    testApiKey: 'Test Connection',
    testing: 'Testing...',
    testSuccess: 'API key is valid',
    testFailed: 'API key is invalid',
    imageGallery: 'Images',
    videoGallery: 'Videos',
    aiGenerated: 'AI Generated',
    userUploaded: 'User Uploaded',
    capturedPhoto: 'Captured Photo',
    capturedVideo: 'Captured Video',
    deleteUploadConfirm: 'Are you sure you want to delete this upload?',
    deleteError: 'Delete failed, please try again',
    noGenerations: 'No content yet',
    noImages: 'No images yet',
    noVideos: 'No videos yet',
    deleteConfirm: 'Are you sure you want to delete this generation?',
    comments: 'Comments',
    noComments: 'No comments yet',
    addComment: 'Add Comment',
    commentPlaceholder: 'Write your comment...',
    submitComment: 'Send',
    deleteCommentConfirm: 'Are you sure you want to delete this comment?',
    commentAs: 'Comment as',
    preview: 'Preview',
  },
  host: {
    login: 'Host Login',
    loginHint: 'Enter workshop code and host password',
    password: 'Host Password',
    enterPassword: 'Enter host password',
    confirmPassword: 'Confirm host password',
    enterDashboard: 'Enter Dashboard',
    createWorkshop: 'Create New Workshop',
    createWorkshopHint: 'Set up a new workshop session',
    workshopName: 'Workshop Name',
    enterWorkshopName: 'Enter workshop name',
    creating: 'Creating workshop...',
    createSuccess: 'Workshop created successfully!',
    shareInfo: 'Share this code or QR with participants',
    copyCode: 'Copy Code',
    codeCopied: 'Code copied!',
    goToDashboard: 'Go to Dashboard',
    advancedSettings: 'Advanced Settings',
    teamSize: 'Team Size',
    imageQuota: 'Image Quota per Team',
    videoQuota: 'Video Quota per Team',
    maxParticipants: 'Max Participants',
    dashboard: 'Host Dashboard',
    bigScreen: 'Big Screen',
    startGrouping: 'Form Teams',
    reshuffleTeams: 'Reshuffle Teams',
    startTimer: 'Start Timer',
    pauseTimer: 'Pause Timer',
    resumeTimer: 'Resume Timer',
    resetTimer: 'Reset Timer',
    setDuration: 'Set Duration',
    setPhase: 'Set Phase',
    uploadMaterials: 'Upload Materials',
    endSession: 'End Session',
  },
  materials: {
    title: 'Materials',
    assigned: 'Assigned Material',
    notAssigned: 'No material assigned yet',
    assignRandom: 'Assign Randomly',
    uploading: 'Uploading...',
    dropHere: 'Drop files here to upload',
    orClick: 'or click to select files',
    confirmDelete: 'Are you sure you want to delete this material?',
    available: 'Available',
    disabled: 'Disabled',
    enable: 'Enable',
    disable: 'Disable',
    empty: 'No materials uploaded yet',
    // Phase 3 example materials tabs
    exampleMaterials: 'Example Materials',
    teamMaterials: 'Team Materials',
    exampleHint: 'These will be shown to participants in Phase 3 (Example Videos)',
    teamHint: 'These will be assigned to teams in Phase 5+ for interactive practice',
  },
  phase3: {
    title: 'Example Videos',
    subtitle: 'Watch audio description demonstration videos',
    noExamples: 'No example materials available',
    followHost: 'Follow along with the presentation on the big screen',
    previous: 'Previous',
    next: 'Next',
  },
  timer: {
    running: 'Timer Running',
    paused: 'Timer Paused',
    stopped: 'Timer Stopped',
  },
  status: {
    online: 'Online',
    offline: 'Offline',
  },
  summary: {
    title: 'Workshop Summary',
    results: 'Team Results',
    timeline: 'Activity Timeline',
    shareCard: 'Share Card',
    downloadCard: 'Download Share Card',
    shareToSocial: 'Share to Social Media',
    generateShare: 'Generate Share Card',
    shareHint: 'Create a shareable image of your workshop experience',
    noCreation: 'No creation submitted',
    shareComingSoon: 'Share card generation coming soon!',
  },
  activity: {
    session_created: 'Workshop created',
    participant_joined: 'Participant joined',
    participant_left: 'Participant left',
    phase_changed: 'Phase changed',
    teams_formed: 'Teams formed',
    timer_started: 'Timer started',
    timer_paused: 'Timer paused',
    timer_reset: 'Timer reset',
    material_assigned: 'Material assigned',
    creation_submitted: 'Creation submitted',
    session_ended: 'Workshop ended',
  },
  accessibility: {
    skipToMain: 'Skip to main content',
    toggleTheme: 'Toggle theme',
    toggleLanguage: 'Toggle language',
    highContrast: 'High contrast mode',
    increaseFont: 'Increase font size',
    decreaseFont: 'Decrease font size',
  },
  phase2: {
    subtitle: 'Learn about audio description fundamentals',
    noContent: 'No content available',
    slide: 'Slide',
    hostControls: 'Phase 2 Controls',
    currentSlide: 'Current slide',
    followAlong: 'Follow along with the presentation on the big screen',
    definition: {
      title: 'What is Audio Description?',
      text: 'Audio description is a narration service that describes visual elements of content for people who are blind or have low vision. It provides verbal descriptions of key visual elements such as actions, scenes, facial expressions, costumes, and settings.',
      highlight: '"Audio description transforms visual content into an inclusive experience, making media accessible to everyone."',
    },
    scenarios: {
      title: 'Where is Audio Description Used?',
      film: {
        name: 'Film & Television',
        desc: 'Movies, TV shows, streaming content',
      },
      live: {
        name: 'Live Events',
        desc: 'Theater, sports, concerts',
      },
      museum: {
        name: 'Museums & Exhibitions',
        desc: 'Art galleries, exhibits, tours',
      },
      digital: {
        name: 'Digital Content',
        desc: 'Websites, apps, social media',
      },
    },
    principles: {
      title: 'Key Principles',
      objectivity: {
        name: 'Maintain Objectivity',
        desc: 'Describe what you see, not what you think or feel. Avoid adding personal interpretations or emotional commentary.',
      },
      style: {
        name: 'Allow Personal Style',
        desc: 'While staying objective, your unique perspective and vocabulary naturally shape the description. This personal style is acceptable and adds richness.',
      },
      artForm: {
        name: 'Audio Description as Art',
        desc: 'Audio description is an independent art form. A good description can be as creative and engaging as the visual content itself.',
      },
    },
    history: {
      title: 'History of Audio Description',
      usOrigin: 'US Origin',
      usOriginDesc: 'Gregory Frazier conceptualized audio description at San Francisco State University in 1974.',
      liveTheater: 'Live Theater',
      liveTheaterDesc: 'The Pfanstiehls created the first live audio description program at Arena Stage in 1981.',
      dvsBirth: 'DVS Birth',
      dvsBirthDesc: 'WGBH launched Descriptive Video Service (DVS) in 1990, bringing AD to mainstream television.',
      chinaStart: 'China Development',
      chinaStartDesc: 'Hongdandan founded in 2003; Bright Cinema launched in 2017, producing 800+ accessible films.',
    },
    humanAI: {
      title: 'Human-AI Collaboration',
      owlMetaphor: '"Let AI be the owl on your shoulder—helping you become wiser, not thinking for you."',
      owlSource: '— Professor Christopher Dede, Harvard University',
      cognitivePartner: 'Cognitive Partner',
      cognitivePartnerDesc: 'AI can enhance our description abilities, but human creativity and emotional insight remain irreplaceable.',
      balanceTitle: 'The Art of Balance',
      balanceDesc: 'Use AI as a tool for growth, not as a crutch for dependency.',
    },
    philosophy: {
      title: 'Philosophy of Audio Description',
      artFormTitle: 'An Independent Art Form',
      artFormDesc: 'Audio description is not just translation—it is creative interpretation, transforming visual into auditory experience.',
      personalStyleTitle: 'Personal Style',
      personalStyleDesc: 'Within the framework of objective description, your unique perspective and word choices naturally shape the description.',
      emotionalTitle: 'Emotional Resonance',
      emotionalDesc: 'Excellent audio description can evoke emotional responses just like the visual content itself.',
    },
    comparison: {
      title: 'Comparison Exercise',
      instruction: 'Compare "objective description" with "free-style description"',
      objectiveLabel: 'Objective Description',
      objectivePlaceholder: 'Describe the facts you see...',
      creativeLabel: 'Creative Description',
      creativePlaceholder: 'Add your feelings and interpretation...',
      submitButton: 'Submit Comparison',
      discussPrompt: 'Discussion: How do personal experiences influence our expression?',
    },
  },
  workshopCreate: {
    createWorkshop: 'Create Workshop',
    editWorkshop: 'Edit Workshop',
    createHint: 'Set up a new workshop and publish when ready',
    basicInfo: 'Basic Information',
    workshopName: 'Workshop Name',
    workshopNamePlaceholder: 'Audio Description Workshop - Session 3',
    description: 'Description',
    descriptionPlaceholder: 'Enter workshop description...',
    descriptionTooLong: 'Description must be under 500 characters',
    scheduledDate: 'Scheduled Date',
    scheduledTime: 'Scheduled Time',
    participantSettings: 'Participant Settings',
    maxParticipants: 'Maximum Participants',
    participantHint: 'Participants will be paired into {teams} teams',
    advancedSettings: 'Advanced Settings',
    qrSettings: 'QR Code Settings',
    qrExpiry: 'QR Code Expiry',
    aiSettings: 'AI Generation Settings',
    imageQuotaPerTeam: 'Image Quota per Team',
    videoQuotaPerTeam: 'Video Quota per Team',
    estimatedUsage: 'Estimated: {imageQuota} images × {teams} teams = {totalImage} | {videoQuota} videos × {teams} teams = {totalVideo}',
    teamSettings: 'Team Settings',
    teamSize: 'Team Size',
    people: 'people',
    teamAssignment: 'Assignment Method',
    assignment: {
      random: 'Random',
      manual: 'Manual',
    },
    phaseDurations: 'Phase Durations (minutes)',
    phases: {
      lobby: 'Lobby',
      teams: 'Team Formation',
      aiGeneration: 'AI Generation',
      creation: 'Creation',
      recording: 'Recording',
      sharing: 'Sharing',
      wrapup: 'Wrap-up',
    },
    totalDuration: 'Total Duration',
    saveDraft: 'Save Draft',
    publish: 'Publish Workshop',
    publishing: 'Publishing...',
    setPassword: 'Set Host Password',
    passwordHint: 'Set a password for hosts to access the workshop dashboard',
    passwordTooShort: 'Password must be at least 4 characters',
    confirmPublish: 'Publish',
    publishSuccess: 'Workshop Published!',
    shareInfo: 'Share this code or QR with participants',
  },
  lobby: {
    yourIntro: 'Your Introduction',
    otherParticipants: 'Other Participants',
    textIntroLabel: 'Or type your introduction',
    textIntroPlaceholder: 'Tell us a bit about yourself...',
    noOtherParticipants: 'No other participants yet',
    completeIntroToContinue: 'Complete your introduction to continue',
    waitingForHost: 'Waiting for host to form teams...',
    participantsCount: '{count} participants',
    noParticipants: 'No participants',
    total: 'Total',
    noIntroYet: 'No intro yet',
    editIntro: 'Edit Introduction',
    teammatesIntros: "Teammates' Introductions",
  },
  intro: {
    record: 'Record',
    stop: 'Stop',
    play: 'Play',
    reRecord: 'Re-record',
    recordingUnsupported: 'Recording is not supported in this browser.',
    recordingError: 'Could not access microphone. Please check permissions.',
    hint: 'Recommended: 10-30 seconds',
  },
  phaseNav: {
    title: 'Phases',
    expand: 'Expand phases',
    collapse: 'Collapse phases',
    currentPhase: 'Current phase',
    viewingPhase: 'Viewing',
    viewingPast: 'viewing past',
    backToCurrent: 'Back to current',
    goToCurrent: 'Go to current phase',
  },
  phase4: {
    title: 'Technical Guidance',
    subtitle: 'Set up AI image generation tools',
    sections: {
      login: 'Account Login',
      apiKey: 'API Key Creation',
      mcp: 'MCP Activation',
      config: 'Configuration',
      test: 'Testing',
    },
    navigation: {
      previous: 'Previous',
      next: 'Next',
      complete: 'Complete',
      step: 'Step',
    },
    actions: {
      zoomIn: 'Zoom in',
      zoomOut: 'Zoom out',
      copyCode: 'Copy code',
      close: 'Close',
    },
    tips: {
      clickToZoom: 'Click image to zoom',
      useArrowKeys: 'Use arrow keys to navigate',
    },
    completion: {
      title: 'Setup Complete!',
      message: 'You can now use AI image generation in your workshop.',
    },
  },
  phase5: {
    title: 'Interactive Practice',
    subtitle: 'Practice audio description with your team',
    instructionsTitle: 'Practice Instructions',
    instructionsText: 'Work with your team to practice describing the materials. The describer observes and describes while the AI operator generates images based on the descriptions.',
    tips: {
      title: 'Tips for Good Audio Description',
      tip1: 'Focus on the most important visual elements first',
      tip2: 'Use clear, simple language that creates mental images',
      tip3: 'Describe actions, colors, positions, and relationships',
    },
  },
  phase6: {
    title: 'Creation',
    subtitle: 'Create your audio description work with AI assistance',
  },
  videoMaker: {
    title: 'Video Maker',
    openMaker: 'Create Video',
    phase5Reminder: 'Use images and videos from AI Generation, or generate more there',
    goToPhase5: 'Go to AI Generation',
    mediaLibrary: 'Media Library',
    timeline: 'Timeline',
    duration: 'Duration',
    maxDuration: '60 seconds max',
    addMedia: 'Add',
    addAudio: 'Add Audio',
    audioOverlay: 'Audio Overlay',
    replaceAudio: 'Replace Original Audio',
    preview: 'Preview',
    play: 'Play',
    pause: 'Pause',
    export: 'Export Video',
    exporting: 'Exporting...',
    exportSuccess: 'Video exported successfully',
    exportError: 'Failed to export video',
    noContent: 'No content added yet',
    emptyLibrary: 'No AI generated content available',
    trimStart: 'Trim Start',
    trimEnd: 'Trim End',
    removeTrack: 'Remove',
    seconds: 's',
    remaining: 'Remaining',
    images: 'Images',
    videos: 'Videos',
    video: 'Video',
    tracks: 'Tracks',
    format: 'Format',
    download: 'Download',
    exportHint: 'Export to WebM format',
    noAudio: 'No audio overlay',
    clearAudio: 'Clear audio',
    audioDuration: 'Audio duration',
    chooseAudio: 'Choose Audio File',
    supportedFormats: 'Supports MP3, WAV, OGG',
    upload: 'Upload',
    record: 'Record',
    recordedAudio: 'Recorded Audio',
    invalidAudioFile: 'Please select a valid audio file',
    audioLoadError: 'Failed to load audio file',
    aiImages: 'AI Images',
    aiVideos: 'AI Videos',
    uploadedImages: 'Photos',
    uploadedVideos: 'Uploaded Videos',
  },
  errors: {
    sessionNotFound: 'Workshop session not found',
    sessionEnded: 'This workshop has ended',
    invalidCode: 'Invalid workshop code',
    invalidCredentials: 'Invalid email or password',
    invalidPassword: 'Invalid password',
    nicknameRequired: 'Nickname is required',
    networkError: 'Network error, please try again',
    authRequired: 'Please login to continue',
    authFailed: 'Authentication failed',
    quotaExceeded: 'Generation quota exceeded',
    joinFailed: 'Failed to join workshop',
    noTeamAssigned: 'You have not been assigned to a team yet',
    pageNotFound: 'Page Not Found',
    pageNotFoundHint: 'The page you are looking for does not exist.',
    passwordMismatch: 'Passwords do not match',
    workshopNameRequired: 'Workshop name is required',
    passwordRequired: 'Password is required',
    createFailed: 'Failed to create workshop',
    adminRequired: 'Admin privileges required',
    emailAlreadyExists: 'This email is already registered',
    passwordTooShort: 'Password is too short, minimum 6 characters',
    publishFailed: 'Failed to publish workshop',
    uploadFailed: 'Failed to upload file',
  },
  session: {
    accessControls: 'Access Controls',
    archive: 'Archive',
    unarchive: 'Unarchive',
    hide: 'Hide',
    unhide: 'Unhide',
    archiveTitle: 'Archive Session',
    archiveDesc: 'When archived, no one can modify',
    hideTitle: 'Hide Session',
    hideDesc: 'When hidden, only host can modify',
    archivedMessage: 'This session is archived. No changes can be made.',
    hiddenMessage: 'This session is in host-only mode. Only the host can make changes.',
  },
  approval: {
    modeTitle: 'Require Approval',
    modeDesc: 'When enabled, new participants need host approval to join',
    enabled: 'Enabled',
    disabled: 'Disabled',
    pendingTitle: 'Pending Approval',
    pendingUserTitle: 'Waiting for Approval',
    pendingUserMessage: 'Your request to join has been sent to the host.',
    pendingUserHint: 'You will be redirected automatically once approved.',
    sessionName: 'Session',
    approve: 'Approve',
    reject: 'Reject',
    rejectedTitle: 'Request Rejected',
    rejectedMessage: 'Your request to join was not approved by the host.',
    goHome: 'Go Home',
    retry: 'Request Again',
    cancel: 'Cancel',
    unknownUser: 'Unknown User',
  },
}
